import styled from 'styled-components';
import { AVATAR_SIZE_MAP } from './avatar-initials.utils';

export const AvatarInitialSC = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &.Xlarge {
    width: ${AVATAR_SIZE_MAP['Xlarge']}px;
    height: ${AVATAR_SIZE_MAP['Xlarge']}px;
    ${({ theme }) => theme.mappedTypography.h3.default};
  }

  &.large {
    width: ${AVATAR_SIZE_MAP['large']}px;
    height: ${AVATAR_SIZE_MAP['large']}px;
    ${({ theme }) => theme.mappedTypography.h4.default};
  }

  &.medium {
    width: ${AVATAR_SIZE_MAP['medium']}px;
    height: ${AVATAR_SIZE_MAP['medium']}px;
    ${({ theme }) => theme.mappedTypography.h5.default};
  }

  &.small {
    width: ${AVATAR_SIZE_MAP['small']}px;
    height: ${AVATAR_SIZE_MAP['small']}px;
    ${({ theme }) => theme.mappedTypography.h6.default};
  }

  &.Xsmall {
    width: ${AVATAR_SIZE_MAP['Xsmall']}px;
    height: ${AVATAR_SIZE_MAP['Xsmall']}px;
    ${({ theme }) => theme.mappedTypography.captionSmall.default};
  }
`;
